import { ThunkDispatch } from "redux-thunk";
import { IRootState } from "../store";
import { IAuthActions } from "../actions/auth.action";
import { IErrorDto } from "../../interfaces/dto/error.dto";
import {
  loginAction,
  loginFailureAction,
  loginSuccessAction,
  logoutAction,
  forgotPasswordAction,
  setEmailAction,
  signupAction,
  signupFailureAction,
  signupSuccessAction,
  forgotPasswordSuccessAction,
  forgotPasswordFailureAction,
} from "../actions/auth.action";
import {
  login,
  signUp,
  forgotPassword,
  updatePassword,
} from "../../services/auth";
import {
  setSessionLocalStorage,
  unsetSessionLocalStorage,
} from "../../utils/local-storage";
import { IloginDto } from "../../interfaces/dto/auth.dto";
import { getBusinessThunk } from "./user.thunk";
import { ApiCode } from "../../enum/auth";

interface IAuthLogin {
  email: string;
  password: string;
  name: string;
}

export const loginThunk =
  (payload: IAuthLogin) =>
  async (
    dispatch: ThunkDispatch<IRootState, void, IAuthActions>,
  ): Promise<void> => {
    dispatch(loginAction());
    dispatch(setEmailAction(payload.email));

    const result = await login(payload);

    if (result.error) {
      dispatch(loginFailureAction(result.error));
    } else {
      dispatch(loginSuccessAction(loginSuccessHandler(result)));
      dispatch(getBusinessThunk());
    }
  };

export const signUpThunk =
  (payload: IAuthLogin) =>
  async (dispatch: ThunkDispatch<IRootState, void, IAuthActions>) => {
    dispatch(signupAction());
    dispatch(setEmailAction(payload.email));

    const result = await signUp(payload);

    dispatch(
      result.error
        ? signupFailureAction(result.error)
        : signupSuccessAction(result),
    );
  };

export const forgotPasswordThunk =
  (email: string) =>
  async (dispatch: ThunkDispatch<IRootState, void, IAuthActions>) => {
    dispatch(forgotPasswordAction());

    const result = await forgotPassword({ email });

    dispatch(
      result.error
        ? forgotPasswordFailureAction(result.error)
        : forgotPasswordSuccessAction(result),
    );

    return {
      isError: !!result.error,
      message: result.error ? result.error : result.message,
    };
  };

export const updatePasswordThunk =
  (password: string, token: string) =>
  async (dispatch: ThunkDispatch<IRootState, void, IAuthActions>) => {
    dispatch(forgotPasswordAction());

    const result = await updatePassword({ password, token });

    dispatch(
      result.error
        ? forgotPasswordFailureAction(result.error)
        : forgotPasswordSuccessAction(result),
    );

    return {
      isError: !!result.error,
      message: result.error ? result.error : result.message,
    };
  };

export const logoutThunk =
  () => (dispatch: ThunkDispatch<IRootState, void, IAuthActions>) => {
    unsetSessionLocalStorage();
    dispatch(logoutAction());
  };

const loginSuccessHandler = (result: IloginDto) => {
  const { token, id: userId, expires, role } = result;

  setSessionLocalStorage({ token, userId, expires, role });

  return {
    token,
    userId,
    expires,
    role,
  };
};

export const sessionCheck =
  (payload: IErrorDto) =>
  (dispatch: ThunkDispatch<IRootState, void, IAuthActions>) => {
    if (payload.errorCode === ApiCode.UNAUTHORIZED) {
      dispatch(logoutThunk());

      return false;
    }

    return true;
  };
